import { authService } from '../services/ServiceContainer'
import { commonCfg } from 'my-account-common'

export function configureRouter (router) {
  router.beforeEach((to, from, next) => {
    if (!authService.isLoggedIn()) {
      let currentUrl = document.URL
      window.location.href = commonCfg.loginUrl + encodeURIComponent(currentUrl)
    } else {
      next()
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/routerConfig.js